import { useLocation, Link } from 'react-router-dom'
import {ChangeLog} from 'models/ChangeLog'
import { UrlPath } from "utility/routes";

interface ChangeLogState {
    changeLogItem: ChangeLog,
 }

 const LoggDetails: React.FC = () => {

    const location = useLocation()
    const state = location.state as ChangeLogState;
    console.log("User",state)

 return (
      <div className='card'>
    <div className="card-body">
          <h1 className="h3">Endringer {state.changeLogItem.date}</h1>
          <p>Endret av {state.changeLogItem.user.name}</p>
          <h2 className="h6"><a href="endre-telefonnummer.html">Telefonnummer</a></h2>
          <p>Lagt til <em>Vakttelefon 22 33 44 55</em> </p>
          <h2 className="h6"><a href="endre-bransjer.html">Bransje</a></h2>
          <p> Endret fra <em>Advokat</em> til <em>Konsulenter - Bedriftsøkonomi</em></p>
          <p className="mt-4 mb-0"> 
          <Link to={`${UrlPath.Account.Company}/${state.changeLogItem.companyId}/${UrlPath.Account.Actions.Logg}`} className="btn btn-outline-primary"><i className="bi bi-arrow-left"></i> Tilbake</Link>
          </p>
      </div>
      </div>
  )
}
export default LoggDetails
